module.exports = __webpack_public_path__ + "media/images/logo_reversed_24bit_alpha-4b586e9e.png";